export enum ARTICLE_CATEGORIES {
	ALL = '全部消息',
	LATEST = '最新公告',
	MEMBER_CAMPAIGN = '會員活動',
	MEDIA = '媒體報導',
	SECRET_BASE = '私密基地',
	GENDER_EQUITY = '性平之路',
}
